module.exports = __webpack_public_path__ + "static/media/close-icon.29d989d4.svg";